import info from 'shared/src/resource/info'
import numberUtils from 'shared/src/utils/number'

const priceField = ({
  prepend = '',
} = {}) => ({
  id: `${prepend}price`,
  title: 'Price',
  default: 0,
  inputProps: {
    type: 'number',
  },
  helperText: 'What is the price?',
  validate: {
    type: 'number',
    methods: [
      ['required', 'Required'],
      ['moreThan', 0, 'Must be more than zero'],
    ],
  },
})

const priceTypeField = ({
  prepend = '',
} = {}) => ({
  id: `${prepend}priceType`,
  title: 'Unit or Total Cost',
  default: 'unit',
  component: 'radio',
  compact: true,
  row: true,
  options: [{
    title: 'Per unit',
    value: 'unit',
  }, {
    title: 'Total price',
    value: 'total',
  }],
  helperText: 'Is the price per unit a total price?',
  validate: {
    type: 'string',
    methods: [
      ['required', 'Required'],
    ],
  },
})

const amountField = ({
  prepend = '',
} = {}) => ({
  id: `${prepend}amount`,
  title: 'Amount',
  default: 1,
  inputProps: {
    type: 'number',
  },
  helperText: 'What is the number of units the price is for?',
  validate: {
    type: 'number',
    methods: [
      ['required', 'Required'],
      ['moreThan', 0, 'Must be more than zero'],
    ],
  },
})

const unitField = ({
  prepend = '',
  unitType = 'all',
  customUnits = [],
} = {}) => ({
  id: `${prepend}unit`,
  title: 'Unit',
  default: '',
  component: 'unitselect',
  unitType,
  customUnits,
  helperText: 'What is the unit for the price?',
  validate: {
    type: 'string',
    methods: [
      ['required', 'Required'],
    ],
  },
})

const rateSchema = ({
  prepend = '',
  unitType = 'all',
  customUnits = [],
  noUnits = false,
} = {}) => [
  priceField({prepend}),
  amountField({prepend}),
  noUnits ? null : unitField({
    prepend,
    unitType,
    customUnits,
  }),
  priceTypeField({prepend}),
].filter(field => field)

const rateTable = ({
  title = 'Rates',
  id = 'meta.rates',
  unitType = 'all',
  customUnits = [],
  inheritUnit = false,
}) => ({
  id,
  title,
  helperText: 'Add prices for different quantities',
  list: {
    mainField: 'price',
    compact: true,
    equalSpacing: true,
    schema: rateSchema({
      unitType,
      customUnits,
      noUnits: inheritUnit,
    }),
    table: [{
      title: 'Unit Price',
      name: 'unitPrice',
      sortable: true,
      render: (rate, formValues) => {
        return numberUtils.twoDp(info.rateUnitPrice(rate))
      }
    },{
      title: 'Amount',
      name: 'amount',
    }, {
      title: 'Unit',
      name: 'unit',
      render: inheritUnit ? (discount, formValues) => {
        return info.baseUnit(formValues)
      } : null
    }]
  }
})

export default {
  priceField,
  priceTypeField,
  amountField,
  unitField,
  rateSchema,
  rateTable,
}
